import React from "react";

export const ButtonsModalActions = ({
  openModalActionsRV,
  inputLoadRequestFileRef,
  inputLoadRemPromRef,
  setOpenUploadXML,
  activeButton,
}) => {
  return (
    <div
      className={`modal-actionsRV ${openModalActionsRV ? " showActions" : ""}`}
    >
      <div className="menu__options">
        <div
          className={`menu__buttons ${
            !activeButton || !activeButton.rem ? "disabled-action" : ""
          }`}
          onClick={
            activeButton &&
            activeButton.rem &&
            (() => inputLoadRemPromRef.current.click())
          }
        >
          <div>Cargar Rem Promedio</div>
        </div>
        <div className="menu__buttons" onClick={() => setOpenUploadXML(true)}>
          <div>Cargar XML Ganadas</div>
        </div>
        <div
          className={`menu__buttons ${
            !activeButton || !activeButton.xmlMeller ? "disabled-action" : ""
          }`}
        >
          <div>Generar XML Meller</div>
        </div>
        <div
          className={`menu__buttons ${
            !activeButton || !activeButton.excel ? "disabled-action" : ""
          }`}
        >
          <div>Descargar Excel</div>
        </div>
      </div>
    </div>
  );
};
